/**
 * @Author : ShaJiaJing
 * @Date : 2019/9/5
 * @Version : 1.0
 * @Content : 主题页
 */
export default {
  // 各种状态
  status: {
    activated: '已激活'
  },
  // 录像回放
  play: {
    title: '录像回放',
    info: ['机器人', '流程', '当前状态', '开始时间', '结束时间'],
    list: ['录像编号', '地址', '操作系统', '开始时间', '结束时间'],
    tips: ['暂无录像！']
  },
  // KEY管理
  license: {
    // 能力管理、应用管理
    index: {
      title: 'KEY管理',
      // 概览
      overview: {
        title: '概览',
        operation: ['管理KEY', '创建KEY'],
        text: '已创建KEY：{n}个'
      },
      // 用量
      dosage: {
        title: '用量',
        table: ['能力产品', '调用量', '失败', '失败率'],
        operation: ['查看详情']
      },
      // 服务列表
      service: {
        title: '服务列表',
        table: ['组件名称', '免费限制', '点数（点/次）']
      }
    },
    // KEY列表
    list: {
      title: 'KEY列表',
      table: ['名称', 'API Key', 'SecretKey', '创建时间'],
      operation: ['删除', '使用详情', '创建'],
      toggle: ['显示', '隐藏']
    },
    // 新增应用
    new: {
      title: '新增KEY',
      form: ['名称', '描述'],
      operation: ['取消', '保存并创建'],
      rules: ['名称必填']
    }
  },
  // 财务中心
  finance: {
    // 财务总览
    overview: {
      title: '财务总览',
      account: {
        title: '账号信息',
        label: '剩余点数',
        operation: '充值'
      },
      consume: {
        title: '消费信息',
        content: ['今日消费点数', '本月消费点数', '待开发票金额'],
        point: '{n} 点'
      }
    },
    // 收支明细
    details: {
      title: '收支明细',
      fee: '免费使用',
      table: ['编号', '时间', '产品', '交易类型', '点数', '余额'],
      operation: ['详情'],
      conditions: ['时间范围', 'KEY', '产品', '交易类型'],
      type: {
        all: '全部',
        consumption: '消费',
        recharge: '充值'
      },
      detail: {
        title: '详情',
        table: ['产品名', '来源', '时间', '应用名', '点数', '区域', '识别结果', '状态'],
        status: {
          success: '成功',
          fail: '失败'
        }
      }
    }
  },
  // 任务管理
  task: {
    action: {
      0: '播放',
      1: '重做',
      2: '启动',
      3: '停止',
      4: '重启',
      5: '删除',
      6: '业务日志',
      7: '运行日志下载',
      8: '更多'
    }
  }
}
